// Chakra imports
import { 
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Divider,
  Text,
  useColorModeValue,
  Flex
} from '@chakra-ui/react';

// Components
import { BreadcrumbArrowIcon } from 'components/Icons/Icons';

function Breadcrumbs(props) {
  const { target, url, current } = props;

  const targetColor = useColorModeValue('#7787B0', '#8794C2');
  const styleGeneral = { 
    color: targetColor,
    fontSize: '16px',
    fontWeight: '500',
    letterSpacing:' -0.4px',
    textTransform: 'uppercase'
  };

  return (
    <Box>
      <Breadcrumb separator={<BreadcrumbArrowIcon color={targetColor} />}>

        <BreadcrumbItem>
          <BreadcrumbLink 
            href={url} 
            style={styleGeneral}>
            {target}
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem className="active">
          <BreadcrumbLink 
            href='#'
            style={{ 
              ...styleGeneral,
              background: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)',
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              '-webkit-text-fill-color': 'transparent',
            }}
            >{current}</BreadcrumbLink>
        </BreadcrumbItem>

      </Breadcrumb>
    </Box>
  );
}

export default Breadcrumbs;